import React, { Component } from 'react';
import { connect } from 'shalala';

import { useStore } from '../../../store';
import Loading from '../../../facturotopia/loading/Loading';
import PageHeader from '../../../support/page-header/PageHeader';
import ComprobanteDownloadActions from '../comprobantes/info/components/ComprobanteDownloadActions';
import AutofacturacionTicketGeneralInfo from '../../../modulos/autofacturacion/tickets/components/AutofacturacionTicketGeneralInfo';

class AutofacturacionTicketInfo extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { id } = props.match.params;
    const { data = {} } = props.location.state || {};

    this.state = {
      data: !!data.id ? { ...data } : { id },
    };

    props.info.reset();
    props.info.setInfo(this.state.data);
  }

  componentDidMount() {
    const { data } = this.state;

    if (!data.codigo) {
      this.props.history.replace('/ext/receptores/autofacturacion/tickets');

      return;
    }

    if (!!data && !data.tracking) {
      this.props.info.detail(data.id);
    }
  }

  componentWillUnmount() {
    this.setState = () => {};
  }

  render() {
    const { data = {}, busy } = this.props;

    if (!!busy) {
      return <Loading className="text-info" />;
    }

    return (
      <>
        <PageHeader
          to="/ext/receptores/autofacturacion/tickets"
          text="Tickets"
        />

        {!!data.cfdi_uuid && [1, 'success', -1, 'cancelled'].indexOf(data.status) > -1 && (
          <div className="text-right mb-3 ">
            <ComprobanteDownloadActions data={{ uuid: data.cfdi_uuid }} />
          </div>
        )}

        <AutofacturacionTicketGeneralInfo data={data} />
      </>
    );
  }
}

const mapState = (store) => {
  return store.autofacturacion.info;
};

const mapActions = (actions) => {
  return {
    info: actions.autofacturacion.info,
  };
};

export default connect(useStore, mapState, mapActions)(AutofacturacionTicketInfo);
